import React from "react";
import { ToastContainer } from "react-toastify";
import ViewContactRequest from "../../components/Requests/ContactRequest/ViewContactRequest";

export const ViewContactRequestPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewContactRequest />
        </div>
      </div>
    </div>
  );
};
